import { Injectable } from '@angular/core';
import { DataService } from './data.service';

@Injectable({
  providedIn: 'root'
})
export class PackageDataService {

  constructor(private dataService: DataService) { }

  GetSPAndProductListByCoordinates(paramFilters: any) {
    return this.dataService.getRecordWithParams('/api/coverage/GetSPAndProductListByCoordinates', paramFilters);
  };

  GetProductPackeageList() {
    return this.dataService.getRecord('/api/coverage/GetProductPackeageList');
  };


  getFilteredListOfProduct(postData: any) {
    return this.dataService.post('/api/coverage/GetFilteredListOfProduct', postData);
  };

  saveSubCategoryOrder(postData: any) {
    return this.dataService.post('/api/productSubCategory/saveSubCategoryOrder', postData);
  };

  getAreaProductRecord(postData: any) {
    return this.dataService.post('/api/productSubCategory/getAreaProductRecord', postData);
  };

  getProductsByArea(id: number) {
    return this.dataService.getRecord('/api/coverage/getProductsByArea/' + id);
  };
  getImportantProductId() {
    return this.dataService.getRecord('/api/productDetail/getImportantProductId/');
  };
  getProductONTDetail(productId: number) {
    return this.dataService.getRecord('/api/coverage/GetProductONTDetail/' + productId);
  }
  GetCompleteListOfProduct(svcProviderId: number) {
    return this.dataService.getRecord('/api/coverage/GetCompleteListOfProduct/' + svcProviderId);
  };

  GetAllServiceProviderList() {
    return this.dataService.getRecord('/api/coverage/GetAllServiceProviderList');
  };
  getModifiedProductList() {
    return this.dataService.getRecord('/api/productDetail/getModifiedProductId');
  };
  GetFeasiblePromoBySPId(id) {
    return this.dataService.post('/api/productDetail/GetFeasiblePromoBySPId', id);
  };
}
